<ng-container *transloco="let t">
    <div
        class="container"
        fxLayout="row"
        fxLayoutAlign.xs="center"
        fxLayoutAlign.sm="center"
    >
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayout.sm="column"
            fxFlex.xs="90%"
            fxFlex.sm="90%"
            fxLayoutAlign="space-between start"
            fxLayoutAlign.xs="space-between center"
            fxLayoutAlign.sm="space-between center"
        >
            <h1 class="visually-hidden">
                {{ t("application.tab.personal-info") }}
            </h1>
            <div
                fxFlex="612px"
                fxLayoutAlign="center center"
                class="left-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
            >
                <mat-card appearance="outlined">
                    <img
                        src="assets/img/application-icons/personal-info-icon.svg"
                        alt="personal-info-icon"
                    />
                    <h2>{{ t("application.personal-info.header") }}</h2>
                    <p
                        class="title"
                        *ngIf="client$ | async as client"
                        [innerHTML]="client.personalInfoHtml"
                    ></p>
                    <p class="subtitle">
                        {{ t("application.personal-info.sub-title") }}
                    </p>
                    <form
                        [formGroup]="personalInformation"
                        (ngSubmit)="onSubmitted()"
                        fxLayout="column"
                    >
                        <ng-container *ngIf="formSections$ | async as sections">
                            <div
                                *ngFor="let section of sections; let i = index"
                                #sectionWrapper
                            >
                                <ng-container *ngIf="isSectionVisible(section)">
                                    <mat-divider *ngIf="i > 0"></mat-divider>
                                    <div
                                        class="sub-title"
                                        *ngIf="
                                            section.title ||
                                            section.titleKey ||
                                            section.flyoutKey
                                        "
                                    >
                                        <h3
                                            *ngIf="
                                                section.title ||
                                                section.titleKey
                                            "
                                        >
                                            {{
                                                t(
                                                    section.titleKey ??
                                                        section.title ??
                                                        section.key ??
                                                        "",
                                                    {
                                                        providerName:
                                                            singleProviderName
                                                    }
                                                )
                                            }}
                                        </h3>
                                        <app-section-flyout
                                            [flyoutKey]="section.flyoutKey"
                                            [active]="activeFlyoutIndex === i"
                                            [flipUp]="
                                                flyoutFlipUp &&
                                                activeFlyoutIndex === i
                                            "
                                        />
                                    </div>
                                    <p
                                        *ngIf="
                                            section.description ||
                                            section.descriptionKey
                                        "
                                    >
                                        {{
                                            t(
                                                section.descriptionKey ??
                                                    section.description ??
                                                    "",
                                                {
                                                    providerName:
                                                        singleProviderName
                                                }
                                            )
                                        }}
                                    </p>

                                    <div *ngFor="let row of section.rows">
                                        <app-dynamic-form
                                            [formGroup]="personalInformation"
                                            [fields]="row.fields"
                                            [formSubmitted]="submitted"
                                            [sectionValidators]="
                                                getSectionValidators(section)
                                            "
                                        >
                                        </app-dynamic-form>
                                    </div>
                                    <mat-error
                                        *ngFor="
                                            let validator of getSectionErrors(
                                                section
                                            )
                                        "
                                    >
                                        {{
                                            t(
                                                validator.messageKey ??
                                                    validator.message ??
                                                    validator.name
                                            ) ??
                                                validator.messageKey ??
                                                validator.message
                                        }}
                                    </mat-error>
                                </ng-container>
                            </div>
                        </ng-container>

                        <button
                            mat-stroked-button
                            class="submit"
                            type="submit"
                            [disabled]="submitting"
                        >
                            {{ t("application.save-and-continue") }}
                        </button>
                    </form>
                </mat-card>
            </div>
            <div
                fxFlex="334px"
                fxLayoutAlign="center center"
                class="right-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxHide.xs
                fxHide.sm
            >
                <mat-card appearance="outlined" style="box-shadow: none">
                    <h2>{{ t("application.summary-card.header") }}</h2>
                    <p class="small">
                        {{ t("application.summary-card.title") }}
                    </p>
                    <div *ngFor="let provider of selectedProviders">
                        <p class="title">
                            {{ provider.providerName }}
                        </p>
                        <ul>
                            <li *ngFor="let program of provider.programs">
                                {{ program }}
                            </li>
                        </ul>
                        <ul>
                            <li *ngFor="let address of provider.addresses">
                                {{ address }}
                            </li>
                        </ul>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
</ng-container>
